<template>
  <div>
    <span v-for="i in empty_stars" :key="`star-${i}`"
      ><i class="fa me-0 fa-star text-dark"></i
    ></span>
    <a href="#" @click.prevent="quality = item" v-for="(item, i) in type.qualities" :key="`quality-${i}`">
      <i class="fa me-0 fa-star text-dark" v-if="(empty_stars + i + 1) <= quality.stars"></i>
      <i class="fal me-0 fa-star text-dark" v-if="(empty_stars + i + 1) > quality.stars"></i>
    </a>
  </div>
</template>

<script>
export default {
  mounted() {
    this.quality = this.type.qualities[0]
  },

  data() {
    return {
      quality: {}
    };
  },

  props: {
    type: {
      default() {
        return { qualities: [] };
      },
    },

    value: {
      default() {
        return null;
      },
    },
  },

  watch: {
    quality() {
      this.$emit("input", this.quality);
    },
  },

  computed: {
    empty_stars() {
      return (5 - this.type.qualities.length)
    }
  },
};
</script>
